import { createContext, ReactElement, useContext, useReducer } from 'react';

import { AbstractProcessingStrategyEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/ProcessingStrategy/AbstractProcessingStrategyEntity';
import { ErrorResponse } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/types/ErrorResponse';
import { ProcessingStatus } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/types/ProcessingStatus';

const InitialState = {
  processingStatus: 'processing' as ProcessingStatus | null,
  processingStrategyEntity: undefined as AbstractProcessingStrategyEntity | undefined,
  errorResponses: [] as ErrorResponse[],
};

type ProcessingStatusContextInitialState = typeof InitialState;

const reducer = (
  state: ProcessingStatusContextInitialState,
  newState: Partial<ProcessingStatusContextInitialState>,
) => ({
  ...state,
  ...newState,
});

const useSectionReducer = () => {
  const [state, dispatch] = useReducer(reducer, InitialState);

  const update = (newContext: Partial<ProcessingStatusContextInitialState>) => dispatch(newContext);

  return { ...state, update };
};

type ProcessingStatusContextState = ReturnType<typeof useSectionReducer>;

const ProcessingStatusContext = createContext<ProcessingStatusContextState | null>(null);

const ProcessingStatusContextProvider = ({ children }: { children: ReactElement }) => {
  const { ...state } = useSectionReducer();

  return <ProcessingStatusContext.Provider value={{ ...state }}>{children}</ProcessingStatusContext.Provider>;
};

const useProcessingStatusContext = (): ProcessingStatusContextState => {
  const context = useContext(ProcessingStatusContext);

  if (!context) {
    throw new Error('useProcessingStatus Context must be used within an ProcessingStatusContextProvider');
  }
  return context;
};

export { ProcessingStatusContextProvider, useProcessingStatusContext };
